// |-- Built-in Dependencies --|
import React, { useEffect, useState } from "react";

// |-- External Dependencies --|
import { IconType } from "react-icons";
import { BiSearchAlt2 } from "react-icons/bi";

// |-- Internal Dependencies --|
import { Tooltip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ATMInputAdormant from "src/components/UI/atoms/formFields/ATMInputAdormant/ATMInputAdormant";
import { useGetAllWebcourseWithPaginationQuery } from "src/services/WebcourseServices";

// |-- Types --|
type ViewLayoutPropTypes = {
  leftbar?: boolean;
  infoCard?: React.ReactNode;
  actionIcons?: {
    icon: IconType;
    onClick: () => void;
  }[];
  listData?: any[];
  tabs?: {
    label: string;
    icon: IconType;
    path: string;
  }[];
  searchValue?: string;
  onSearch?: (value: string) => void;
  onClickViewMore?: () => void;
  onClickChangeRequestView?: (TICKET_ID: string) => void;
  hideViewMore?: boolean;
  children?: any;
};

const WebCourseSideBarLayout = ({
  leftbar = true,
}: ViewLayoutPropTypes) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [inquiryData, setInquiryData] = useState([]);

  const { data, isLoading, isFetching } = useGetAllWebcourseWithPaginationQuery({

    searchValue: searchValue,
    params: ["courseName",],
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
    } else {
      setInquiryData(data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  return (
    <>
      <div className="h-[calc(100vh-50px)] border-r">

        <div className="w-full flex  h-[calc(100%)] bg-white">
          {/* Left Section Side Bar */}
          <div className="md:block hidden">
            {leftbar === true && (
              <div className="w-[250px]  h-full flex flex-col">
                {/* Search Bar */}

                <div className="px-2 py-2 flex items-center justify-center ">
                  <ATMInputAdormant
                    name=""
                    value={searchValue}
                    placeholder="Search here..."
                    className="h-[40px] shadow-sm border-[1px] focus:border-black"
                    adormant={
                      <BiSearchAlt2 className="text-slate-400 text-xl " />
                    }
                    adormantProps={{
                      position: "start",
                      extraClasses: "bg-white border-0 ",
                    }}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                  {/* Filter Button */}
                </div>

                {/* List */}
                {isLoading || isFetching ? (
                  Array(10)
                    .fill(0)
                    .map((_, index) => {
                      return (
                        <div key={index} className="animate-pulse  h-[50px] p-2">
                          <div className="bg-slate-200 h-full rounded"> </div>
                        </div>
                      );
                    })
                ) : <div className="grow overflow-auto">
                  <div className="px-[8px] flex flex-col min-w-[100%] overflow-y-auto">
                    {inquiryData?.map((ele: any) => {
                      return (
                        <div
                          key={ele?._id}
                          className={`shadow-sm mb-2 border-[1px] border-slate-100 rounded cursor-pointer relative ${ele?._id === id
                            ? "bg-blue-200"
                            : "bg-white"
                            }`}
                          onClick={() =>
                            navigate(`/website-content/web-course/${ele?._id}/details`)
                          }
                        >
                          <div
                            className="py-2 px-4"
                            style={{ userSelect: "text" }}
                          >
                            <Tooltip title={ele?.courseName}>
                              <h3 className="w-full overflow-hidden capitalize truncate text-md min-w-[100%] hover:underline font-medium">
                                {ele?.courseName}
                              </h3>
                            </Tooltip>

                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>}

              </div>
            )}
          </div>
        </div>

      </div>
    </>
  );
};

export default React.memo(WebCourseSideBarLayout);
